import { render, staticRenderFns } from "./yqcrTable.vue?vue&type=template&id=dd930a6c&scoped=true"
import script from "./yqcrTable.vue?vue&type=script&lang=ts"
export * from "./yqcrTable.vue?vue&type=script&lang=ts"
import style0 from "./yqcrTable.vue?vue&type=style&index=0&id=dd930a6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd930a6c",
  null
  
)

export default component.exports